<template>
  <div class="vm-container login-container">
    <div class="auth__content login__box">
      <a
        class="back-link"
        @click="goToLogin()"
      >
        <font-awesome-icon
          size="1x"
          :icon="['fas', 'chevron-left']"
        />
        {{ $t('ManageIdentity.Views.Account.ForgotPasswordConfirmation.Login') }}
      </a>
      <br />
      <h1
        class="login__box__header"
        v-html="$t('ManageIdentity.Views.Account.ResetPassword.Headline')"
      />
      <br />
      <div
        class="login__box__description__two"
        v-html="$t('ManageIdentity.Views.Account.ResetPassword.SubHeadline')"
      />
      <br />
      <b-alert
        :show="passwordInfo"
        dismissible
        variant="primary"
        @dismissed="passwordInfo=false"
      >
        <h6 v-html="$t('ManageIdentity.Views.Account.Register.PasswordHintHeading')" />
        <span v-html="$t('ManageIdentity.Views.Account.Register.SubHeadline')" />
      </b-alert>
      <b-alert
        :show="!passwordIdentical"
        variant="danger"
      >
        <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorConfirmPassword')" />
      </b-alert>
      <b-alert
        :show="resetPasswordFailed"
        variant="danger"
      >
        <span v-html="$t('ManageIdentity.Views.Account.ResetPassword.InvalidToken')" />
      </b-alert>
      <b-alert
        :show="resetPasswordData.Password.length && !passwordState"
        variant="danger"
      >
        <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorRequirementPassword')" />
      </b-alert>
      <b-form-group
        id="fieldset-1"
        label-for="input-1"
      >
        <label :for="'reset-password__email'">
          {{ $t('ManageIdentity.Views.Account.ResetPassword.Email') }}
        </label>
        <b-form-input
          id="reset-password__email"
          v-model="resetPasswordData.Email"
          :placeholder="emailPlaceholder"
          type="email"
          trim
        />
        <label
          id="fieldset-4"
          :for="'reset-password__new-password'"
        >
          <span
            class="labelIcon"
          >
            {{ passwordInf }}
            <font-awesome-icon
              :icon="['fas', 'info-circle']"
              class="faIcon"
              @click="openPasswordInfo()"
            />
          </span>
        </label>
        <div class="password-input-container">
          <b-form-input
            v-if="showPassword"
            id="reset-password__new-password"
            v-model="resetPasswordData.Password"
            :state="passwordState"
            type="text"
          />
          <b-form-input
            v-else
            id="reset-password__new-password"
            v-model="resetPasswordData.Password"
            :state="passwordState"
            type="password"
          />
          <div>
            <button v-if="showPassword" class="btn btn-primary" @click="toggleShow">
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </button>
            <button v-else class="btn btn-primary" @click="toggleShow">
              <font-awesome-icon :icon="['fas', 'eye']" />
            </button>
          </div>
        </div>
        <label :for="'reset-password__confirm-password'">
          {{ $t('ManageIdentity.Views.Account.Register.ConfirmPassword') }}
        </label>
        <div class="password-input-container">
          <b-form-input
            v-if="showPasswordConfirm"
            id="reset-password__confirm-password"
            v-model="resetPasswordData.ConfirmPassword"
            :state="confirmPasswordState"
            type="text"
          />
          <b-form-input
            v-else
            id="reset-password__confirm-password"
            v-model="resetPasswordData.ConfirmPassword"
            :state="confirmPasswordState"
            type="password"
          />
          <div>
            <button v-if="showPasswordConfirm" class="btn btn-primary" @click="toggleShowConfirm">
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </button>
            <button v-else class="btn btn-primary" @click="toggleShowConfirm">
              <font-awesome-icon :icon="['fas', 'eye']" />
            </button>
          </div>
        </div>
      </b-form-group>
      <b-button
        :disabled="!passwordIdentical || !passwordState || !emailState"
        variant="primary"
        class="login__box__login_btn"
        @click.prevent="action"
      >
        <span v-html="$t('ManageIdentity.Views.Account.ResetPassword.btnReset')" />
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import accountPageMixins from '../../mixins/accountPageMixins'
import * as constants from '../../constants/constants'

export default {
  mixins: [accountPageMixins],
  data() {
    return {
      resetPasswordData: {
        context: '',
        language: '',
        shortName: '',
        returnUrl: '',
        Email: '',
        Password: '',
        ConfirmPassword: '',
        Code: '',
      },
      passwordInfo: true,
      resetPasswordFailed: false,
      showPassword: false,
      showPasswordConfirm: false,
    }
  },
  props: {
    returnUrl: {
      type: String,
      default: '/auth/login'
    }
  },
  mounted() {
    const queries = this.$route.query
    const pagParams = this.$store.getters['ModuleConfig/moduleConfig']?.pagParams || ''
    if (queries.user && queries.code) {
      this.resetPasswordData.context = queries.context
      this.resetPasswordData.language = queries.language
      this.resetPasswordData.shortName = queries.shortName
      this.resetPasswordData.returnUrl = `${window.location.origin}${pagParams}${this.returnUrl}`
      this.resetPasswordData.Code = decodeURIComponent(queries.code)
    }
  },
  computed: {
    emailState() {
      return this.resetPasswordData.Email.length > 0 && constants.emailRegex.test(this.resetPasswordData.Email)
    },
    passwordInf() {
      return this.$t('ManageIdentity.Views.Account.ResetPassword.Password')
    },
    passwordIdentical() {
      return this.resetPasswordData.Password === this.resetPasswordData.ConfirmPassword
    },
    passwordRegex() {
      return  constants.passwordRegex
    },
    passwordState() {
      return this.passwordRegex.test(this.resetPasswordData.Password) && this.resetPasswordData.Password.length > 0
    },
    confirmPasswordState() {
      return this.passwordRegex.test(this.resetPasswordData.ConfirmPassword) && this.passwordIdentical
    },
    emailPlaceholder() {
      return this.$t('ManageIdentity.Views.Account.ResetPassword.Email')
    },
  },
  methods: {
    ...mapActions({
      resetPassword: 'AuthV2/resetPassword'
    }),
    openPasswordInfo() {
      this.passwordInfo = true
    },
    async action() {
      const pagParams = this.$store.getters['ModuleConfig/moduleConfig']?.pagParams || ''
      await this.resetPassword(this.resetPasswordData).then((res) => {
        if(this.isUrl(res)) window.location.href = `${window.location.origin}${pagParams}${this.returnUrl}`
        // eslint-disable-next-line max-len
        else if(!res || res.status === 404 || res.status === 400 || res.status === 401) this.resetPasswordFailed = true
      })
    },
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    toggleShowConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm
    },
  }
}
</script>

<style lang="scss" scoped>
.back-link {
  cursor: pointer;
  font-weight: bold;
  svg {
    margin-right: 0.5rem;
  }
}

.login-container{
  display: flex;
  justify-content: center;

  .login__box{
    display: flex;
    justify-content: center;
    flex-direction: column;

    .login__box__login_btn{
      max-width: 200px;
    }
    .login__box__login_btn:disabled{
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .login__box__header, .login__box__description{
      display: flex;
      justify-content: center;
    }

    .login__box__description__two{
      display: flex;
    }

    .login__box__checkbox_link{
      display: flex;
      justify-content: space-between;}
  }
}

@media (max-width: 668px) {
  .login__box__checkbox_link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.auth__content {
  width: 100vw;
  max-width: 800px;
  margin-top: 10px;
  padding: 15px;
}
</style>
<style lang="scss">
  .password-input-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }
    .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      svg{
        fill: #fff;
        width: .875rem;
      }
    }
  }
</style>